import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  type: '',
  body: '',
  buttons: []
}

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotification: (state, action) => {
      state.type = action.payload.type
      state.body = action.payload.body
      state.buttons = action.payload.buttons ? action.payload.buttons : []
    }
  }
})

export const { setNotification } = notificationSlice.actions

export const selectNotification = (state) => state.notification

export default notificationSlice.reducer
